<template>
<div>
  <el-form style="margin-right: 30px" :model="noteForm" :rules="noteRules" ref="noteForm" label-width="120px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="老人类型" prop="">
          <el-select v-fixZoom v-model="noteForm.admission_personnel_type" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in oldPersonType" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="专属服务员" prop="">
          <el-select v-fixZoom v-model="noteForm.servicePerson" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in personArr" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="服务需求" prop="">
          <el-input v-model="noteForm.serviceDemand" placeholder="请输入服务需求"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="特长" prop="">
          <el-select v-fixZoom v-model="noteForm.strongPoint" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in specialArr" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="爱好" prop="">
          <el-input v-model="noteForm.hobby" placeholder="请输入爱好"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="政府购买" prop="">
          <el-radio-group v-model="noteForm.isGovernment">
            <el-radio :label="2">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="政府购买项目" prop="">
          <el-input v-model="noteForm.governmentItem" placeholder="请输入政府购买项目"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="特殊备注" prop="">
          <el-input v-model="noteForm.specialRemark" placeholder="请输入特殊备注"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditNote('noteForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {updateelderly} from '../../../api/yanglaoyuan'

export default {
  name: 'noteInfo',
  props: {
    noteObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isJuJia: false,
      oldPersonRow: '',
      entityelderlyservice: '',
      oldPersonType: [],
      personArr: [],
      specialArr: [],
      noteForm: {
        id: '',
        extra_info: {},
        admission_personnel_type: '',
        servicePerson: '',
        serviceDemand: '',
        strongPoint: '',
        hobby: '',
        isGovernment: '',
        governmentItem: '',
        specialRemark: ''
      },
      noteRules: {
        name: [
          {required: true, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.oldPersonType = this.commonType.getAdmissionPersonnelTypeArr()
    this.specialArr = this.commonType.getSpecialArr()
    this.entityelderlyservice = this.noteObj.entityelderlyservice
    this.oldPersonRow = this.noteObj.oldPersonRow
    this.isJuJia = this.noteObj.isJuJia
    this.getStartNote()
  },
  methods: {
    getStartNote () {
      if (this.oldPersonRow === '' || this.oldPersonRow.id === 0) {
        this.$message({
          message: '请先新增老人基本信息。',
          type: 'warning'
        })
        return
      }
      let info = null
      if (this.oldPersonRow.extra_info && this.oldPersonRow.extra_info !== '') {
        info = JSON.parse(this.oldPersonRow.extra_info)
      }
      this.noteForm = this.commonType.getOldPersonForm(this.oldPersonRow, info)
      console.log(4, this.noteForm)
    },
    closeAddEdit () {
      this.$emit('changeEndNote', {type: 'close'})
    },
    submitAddEditNote (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = vm.commonType.getJsonInfo(vm.noteForm)
          if (vm.isJuJia) {
            vm.$emit('changeEndNote', data.extra_info)
          } else {
            updateelderly(data).then(res => {
              let obj = {
                type: 'isBtnNote',
                noteForm: this.noteForm,
                extra_info: data.extra_info
              }
              vm.$emit('changeEndNote', obj)
              vm.$notify({title: '成功', message: '成功编辑备注信息', type: 'success', duration: 2000})
            }).catch(() => {
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/noteInfo.vue